import { MaintenanceWindowRebootOptionsView } from '../view/MaintenanceWindowRebootOptionsView';
import { templateMaintenanceWindowRebootOptions } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowRebootOptionsWebComponent } from '..';
import { MaintenanceWindowRebootOptionsData } from '../types';
import { PostponeRebootOptions } from '../../../types/common/maintenanceWindowCommonTypes';
import { FormGroupHelper } from '../../../utils/maintenanceWindow/FormGroupHelper';
import { toggleVisibility } from '../../../utils/htmlElement.utils';
import { TimePickerEvents } from '../../../ui/gzTimePicker/types';

export class MaintenanceWindowRebootOptionsController extends BaseWebComponentController {
  public component: MaintenanceWindowRebootOptionsWebComponent;
  public view: MaintenanceWindowRebootOptionsView;
  public viewConstructor: typeof MaintenanceWindowRebootOptionsView;

  constructor(component: MaintenanceWindowRebootOptionsWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowRebootOptionsView,
      viewTemplate: templateMaintenanceWindowRebootOptions,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$radioGroupFormField,
        event: 'radioSelectionChanged',
        callback: this.onRadioSelectionChanged,
      },
      {
        element: this.view.dom.$radioGroupFormField.Input,
        event: 'triggerRevalidation',
        callback: this.restoreRebootOptionsComponentState,
      },
      {
        element: this.view.dom.additionalOptions.$rebootBetweenStartFormField.Input,
        event: TimePickerEvents.CHANGE,
        callback: this.triggerFormValidation,
      },
    ];
  }

  private restoreRebootOptionsComponentState(): void {
    const radioOptionsValue = this.view.dom.$radioGroupFormField.Input.getFormValue();
    this.onRadioSelectionChanged({ detail: { selectedValue: radioOptionsValue } } as WebComponentEvent);
  }

  private triggerFormValidation() {
    this.view.formGroup.validate();
  }

  onRadioSelectionChanged(ev) {
    switch (ev.detail.selectedValue) {
      case PostponeRebootOptions.CUSTOM_TIME.toString():
        this.displayIntervalOptions(false);
        this.displayAfterOptions(false);
        break;
      case PostponeRebootOptions.INTERVAL.toString():
        this.displayIntervalOptions(true);
        this.displayAfterOptions(false);
        break;
      case PostponeRebootOptions.AFTER.toString():
        this.displayIntervalOptions(false);
        this.displayAfterOptions(true);
        break;
    }
    return;
  }

  private displayIntervalOptions(display: boolean): void {
    toggleVisibility(this.view.dom.additionalOptions.$rebootBetweenContainer, display);
    FormGroupHelper.setDisabledFormFields(!display, [
      this.view.dom.additionalOptions.$rebootBetweenStartFormField,
      this.view.dom.additionalOptions.$rebootBetweenEndFormField,
      this.view.dom.additionalOptions.$rebootBetweenMinutesFormField,
      this.view.dom.additionalOptions.$rebootBetweenCustomMessageFormField,
    ]);
  }

  private displayAfterOptions(display: boolean): void {
    toggleVisibility(this.view.dom.additionalOptions.$rebootAfterContainer, display);
    FormGroupHelper.setDisabledFormFields(!display, [
      this.view.dom.additionalOptions.$rebootAfterMinutesFormField,
      this.view.dom.additionalOptions.$rebootAfterCustomMessageFormField,
    ]);
  }

  async getDataForView(): Promise<{ viewData: MaintenanceWindowRebootOptionsData | null; disabled: boolean }> {
    return {
      viewData: this.component.viewData,
      disabled: this.component.disabled,
    };
  }
}
